/* global HSCore */
/* global bootstrap */

import React, { useContext, useEffect, useRef, useState } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import axiosInstance from "../utils/Requests/axios";
import UserContext from "../utils/Contexts/UserContext";
import toast from "react-hot-toast";

function AccessDetailModal({ id, selectedCreds, getAccessDetailsData, domain, setModalState, modalState }) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);

  const [type, setType] = useState(null);
  const [key, setKey] = useState("");
  const [secret, setSecret] = useState("");
  const [primary, setPrimary] = useState(false);
  const [errors, setErrors] = useState({ key: false, secret: false });

  const validateFields = () => {
    const newErrors = {
      key: !key.trim(), 
      secret: !secret.trim(), 
    };
    setErrors(newErrors);
    return !newErrors.key && !newErrors.secret; 
  };
  const handleCheckboxChange = (event) => {
    setPrimary(event.target.checked);
  };

  const handleTypeChange = (event) => {
    setType(Number(event.target.value));
    setKey("");
    setSecret("");
  };

  const resetForm = () => {
    setType(null);
    setKey("");
    setSecret("");
    setPrimary(false);
    setErrors({ key: false, secret: false })
    setModalState(false);
  };
  const modalRef = useRef(null);

  const handleSubmit = async () => {
   if  (!validateFields()) return;
    const url = selectedCreds
      ? `/sellers/${userData?.uuid}/domains/${id}/credentials/${selectedCreds?.uuid}`
      : `/sellers/${userData?.uuid}/domains/${id}/credentials`;

    const payload = {
      type,
      key,
      secret,
      primary,
    };
    try {
       selectedCreds
        ? await axiosInstance.put(url, payload) // PUT for updating
        : await axiosInstance.post(url, payload);
        toast.success(t("Credentials Updated successfully"));
      getAccessDetailsData();
      const modal = bootstrap.Modal.getInstance(modalRef.current);
      modal.hide();
      resetForm();
    } catch (error) {
      console.error("Error saving credentials:", error);
    }
  };

  useEffect(() => {
    if (selectedCreds) {
      setType(selectedCreds.type || 1);
      setKey(selectedCreds.key || "");
      setSecret(selectedCreds.secret || "");
      setPrimary(selectedCreds.primary || false);
    } else {
      setType(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCreds]);

  const hsInitRef = useRef(null);
  useEffect(() => {
    if (modalState && !hsInitRef.current && modalRef.current) {
      HSCore.components.HSTomSelect.init('.js-select-access');
      const modal = new bootstrap.Modal(modalRef.current);
      modal.show();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      hsInitRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalState, modalRef.current]);

  const handleCheckConnection = async () => {
    const url =  `/wordpress/connection/check`
    const payload = {
      credentials: {
        domain,
        username: key,
        password: secret,
        type
      }
    };
    try {
      await axiosInstance.post(url, payload) 

      getAccessDetailsData();
      const modal = bootstrap.Modal.getInstance(modalRef.current);
      modal.hide();
      resetForm();
    } catch (error) {
      console.error("Error saving credentials:", error);
    }
  };
  let tooltipInit = false;
  useEffect(() => {
    if (!tooltipInit) {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      [...tooltipTriggerList].forEach(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
      tooltipInit = true;
    }
  }, [type]);

  return (
    <div
      className="modal fade exportModal"
      id="accessModal"
      tabIndex="-1"
      aria-labelledby="accessModalLabel"
      aria-hidden="true"
      ref={modalRef}
    >
      <div className="modal-dialog modal-dialog-centered w-200">
        <div className="modal-content">
          <div className="modal-header px-3">
            <h3 className="modal-title" id="accessModalLabel">
              {selectedCreds != null
                ? t("Edit Access Details")
                : t("Add Access Details")}
            </h3>
          </div>

          <div className="modal-body pt-2 pb-0 px-3">
            <div
              className="pt-3"
              style={{
                borderTop: "1px solid #2b2f33",
                borderBottom: "1px solid #2b2f33",
              }}
            >
              <div>
                <label className="form-label text-body">
                  {t("Connection Type")}
                </label>
                <div className="tom-select-custom">
                  {type && (
                    <select
                      className="js-select-access form-select form-select-sm"
                      autoComplete="off"
                      data-hs-tom-select-options='{
                      "placeholder": "Select Access Type",
                      "hideSearch": true
                    }'
                      value={type}
                      onChange={handleTypeChange}
                    >
                      <option value={1} selected={selectedCreds?.type === 1}>
                        {t("Wordpress API")}
                      </option>
                      <option value={2} selected={selectedCreds?.type === 2}>
                        {t("WordPress Account")}
                      </option>
                    </select>
                  )}
                </div>
              </div>

              <div className="d-flex gap-3 py-3">
                <div className="w-lg-50">
                  <label className="form-label text-body">
                    {type === 1 ? t("API Key") : t("Username")}
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${
                      errors.key ? "border-danger" : ""
                    }`}
                    value={key}
                    placeholder={t("Enter Key")}
                    onChange={(e) => {
                      setKey(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        key: !key.trim(),
                      }));
                    }}
                  />
                </div>

                <div className="w-lg-50">
                  <label className="form-label text-body">
                    {type === 1 ? t("API Secret") : t("Password")}
                    <i
                      className="bi-question-circle text-body ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title={type === 1 ? t("API Secret") : t("Password")}
                    />
                  </label>
                  <input
                    type="text"
                    className={`form-control form-control-sm ${
                      errors.secret ? "border-danger" : ""
                    }`}
                    value={secret}
                    placeholder={t("Enter Secret")}
                    onChange={(e) => {
                      setSecret(e.target.value);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        secret: !secret.trim(),
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="form-check pb-2 pt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={primary}
                  onChange={handleCheckboxChange}
                />
                <label
                  className="form-check-label"
                  htmlFor="overwriteCurrentOffersCheckbox"
                >
                  {t("Set This Access Details as the primary access method")}{" "}
                </label>
              </div>
            </div>
          </div>

          <div
            className="modal-footer gap-3 gap-sm-2 px-3 py-4"
            style={{ border: "unset" }}
          >
            <button
              type="button"
              className="btn btn-outline-primary py-1 px-5 fs-4"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetForm}
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="btn btn-outline-primary py-1 px-3 fs-4"
              onClick={handleCheckConnection}
              disabled={!key || !secret}
            >
              {t("Check Connection")}
            </button>
            <button
              type="button"
              className="btn btn-primary py-1 px-3 fs-4"
              onClick={handleSubmit}
            >
              {t("Save Changes")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessDetailModal;
